/**
 * Rotates announcement bar slides every 4s when multiple [data-announcement-slide] exist.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-announcement-bar]');
  if (!root) return;
  var slides = root.querySelectorAll('[data-announcement-slide]');
  if (slides.length <= 1) return;
  var i = 0;
  function show(idx) {
    for (var s = 0; s < slides.length; s++) {
      slides[s].classList.toggle('is-active', s === idx);
      slides[s].setAttribute('aria-hidden', s === idx ? 'false' : 'true');
    }
  }
  show(0);
  setInterval(function () {
    i = (i + 1) % slides.length;
    show(i);
  }, 4000);
})();
